import React from 'react';

// Pinta las variables {{...}} como chips: las de queryApi/webHook con el color del nodo
// (y resaltan ese nodo en el lienzo al pasar el mouse); las generales en gris.
export const renderVariableChips = (text) => {
  if (!text || typeof text !== 'string') return text;
  const parts = text.split(/(\{\{[^}]+\}\})/g);
  return parts.map((part, index) => {
    const isVariable = part.startsWith('{{') && part.endsWith('}}');
    if (!isVariable) {
      return <span key={index}>{part}</span>;
    }
    const raw = part;
    const full = raw.slice(2, -2);
    if (!full.includes('.')) {
      return (
        <span
          key={index}
          className="chip"
          style={{
            display: 'inline-block',
            padding: '2px 6px',
            margin: '2px 0px',
            backgroundColor: '#A7ADA7',
            borderRadius: '4px',
            fontWeight: 500,
            fontSize: '9px',
            color: '#fff',
          }}
        >
          {full}
        </span>
      );
    }
    const match = full.match(/^([^.]+)\./);
    const nodeId = match?.[1];
    const typeMatch = full.match(/-(\w+)\./);
    const variableType = typeMatch?.[1];
    const backgroundColor = {
      queryApi: '#7ECCD8',
      webHook: '#FC6530',
    }[variableType] || '#A7ADA7';
    const displayText = full.split('.').slice(1).join('.');
    return (
      <span
        key={index}
        onMouseEnter={() => {
          if (!nodeId) return;
          const nodeElement = document.querySelector(`[data-id="${nodeId}"]`);
          if (nodeElement) nodeElement.classList.add('hover-pulse');
        }}
        onMouseLeave={() => {
          if (!nodeId) return;
          const nodeElement = document.querySelector(`[data-id="${nodeId}"]`);
          if (nodeElement) nodeElement.classList.remove('hover-pulse');
        }}
        style={{
          display: 'inline-block',
          padding: '2px 6px',
          backgroundColor,
          borderRadius: '4px',
          fontWeight: 500,
          fontSize: '12px',
          color: '#fff',
        }}
      >
        {displayText}
      </span>
    );
  });
};
